class TabContainer extends HTMLElement {
    constructor(){
        super();
        this.titleElement = this.querySelector('.tab-title');
        this.content = this.querySelector('.tab-content');
        this.titleElement.addEventListener('click', this.toggle.bind(this));
    }

    toggle = () => {
        this.toggleAttribute('open');
        if(this.hasAttribute('open')){
            this.titleElement.querySelector('.sign').textContent = '-';
            this.content.style.height = this.content.scrollHeight + 'px';
        }else {
            this.titleElement.querySelector('.sign').textContent = '+';
            this.content.style.height = 0 + 'px';
        }
    }
}

customElements.define('tab-container', TabContainer);

